<template>
  <section class="download-christmas">
    <Chip :label="content.topChip" />
    <a
      class="download-christmas__download"
      :href="content.downloadCard.pdfLink"
      target="_blank"
      @click="
        digitalData({
          event: content.downloadCard.event,
          eventDetail: content.downloadCard.eventDetail,
          contentTitle: content.downloadCard.title,
          contentUrl: content.downloadCard.pdfLink,
          ctaLabel: content.downloadCard.title,
        })
      "
    >
      <div class="download-christmas__download__left">
        <div>
          <p class="download-christmas__download__left__title">
            {{ content.downloadCard.title }}
          </p>
          <p class="download-christmas__download__left__subtitle">
            {{ content.downloadCard.subtitle }}
          </p>
        </div>
        <div :style="{ display: 'flex', alignItems: 'center' }">
          <icon
            :data="pageIcons[content.downloadCard.icon]"
            class="download-christmas__download__left__icon"
          ></icon>
          <p class="download-christmas__download__left__hiddenText">
            {{ content.downloadCard.hiddenText }}
          </p>
        </div>
      </div>
      <div class="download-christmas__download__right">
        <div
          class="download-christmas__download__right__image"
          :style="{
            'background-image': `url(${$baseUrl}images/${content.downloadCard.image}.webp)`,
          }"
        ></div>
      </div>
    </a>
    <div class="download-christmas__transparent">
      <p
        v-for="(text, index) in content.transparentCard.texts"
        :key="'text-' + index"
        class="download-christmas__transparent__text"
      >
        {{ text }}
      </p>
    </div>
  </section>
</template>

<script setup>
import { pageIcons } from "../../plugins/page-icons";
import Chip from "../Landing/DumbComponents/Chip.vue";
import { useGoogleAnalytics } from "../../plugins/useGoogleAnalitycs";

const { digitalData } = useGoogleAnalytics();

defineProps({
  content: Object,
});
</script>

<style lang="scss" scoped>
.download-christmas {
  display: flex;
  padding: toRem(80) toRem(153) toRem(100) toRem(143);
  background-color: $secondary-yellow-2;
  position: relative;
  border-bottom: 1px solid $scala-grigi-gray_2;

  &__transparent {
    @include p-l;
    text-align: left;
    min-width: 45%;
    margin-left: 10%;
    padding: toRem(50) 0;

    &__text {
      &:not(:first-child) {
        margin-top: toRem(20);
      }
    }
  }

  &__download {
    background-color: $scala-grigi-gray_1;
    color: $scala-grigi-white;
    min-width: 45%;
    display: flex;
    @include shadow-cards;
    overflow: hidden;

    &__left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: left;
      min-height: toRem(380);
      padding: toRem(10);
      width: 40%;

      &__title {
        @include title-h-2;
      }

      &__subtitle {
        margin-top: toRem(10);
        @include title-h-5;
      }

      &__icon {
        min-width: 2rem;
        min-height: 2rem;

        :deep(path) {
          transition: all 0.3s ease;
          fill: $scala-grigi-white;

          &:last-child {
            stroke: $scala-grigi-white;
          }
        }
      }

      &__hiddenText {
        @include link-m;
        margin-left: toRem(15);
        opacity: 0;
        transition: opacity 0.3s ease;
      }
    }

    &__right {
      width: 60%;
      overflow: hidden;

      &__image {
        transition: transform 0.3s ease;
        height: 100%;
        background-size: cover;
        background-position: center;
      }
    }

    &:hover {
      .download-christmas__download__right__image {
        transform: scale(1.1);
      }
      .download-christmas__download__left {
        &__hiddenText {
          opacity: 1;
        }
        &__icon {
          :deep(path) {
            fill: $primary-yellow;

            &:last-child {
              stroke: $primary-yellow;
            }
          }
        }
      }
    }
  }
}

.tablet,
.mobile {
  .download-christmas {
    flex-direction: column;
    padding: toRem(37) toRem(140) toRem(27) toRem(140);
    border-top: 1px solid $scala-grigi-gray_2;

    &__transparent {
      margin: 0;
      @include p-m;
    }

    &__download {
      &__left {
        &__title {
          @include title-h-3;
        }

        &__subtitle {
          margin-top: toRem(10);
          @include tasselli-titolo-s;
        }
      }

      &:hover {
        .download-christmas__download__right__image {
          transform: scale(1);
        }
        .download-christmas__download__left {
          &__hiddenText {
            opacity: 0;
          }

          &__icon {
            :deep(path) {
              fill: $scala-grigi-white;

              &:last-child {
                stroke: $scala-grigi-white;
              }
            }
          }
        }
      }
    }
  }
}

.mobile {
  .download-christmas {
    padding: toRem(35) toRem(27) toRem(23) toRem(27);
    &__download {
      &__left {
        min-height: toRem(234);
      }

      &__right {
        &__image {
          background-position: center;
          background-size: cover;
        }
      }
    }
  }
}
</style>
